var _path, _animateTransform, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocaliqLoading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 75C150 116.421 116.421 150 75 150C33.5786 150 0 116.421 0 75C0 33.5786 33.5786 0 75 0C116.421 0 150 33.5786 150 75ZM130 75.0002C130 105.376 105.376 130 75 130C44.6243 130 20 105.376 20 75.0002C20 44.6244 44.6243 20 75 20C105.376 20 130 44.6244 130 75.0002Z",
    fill: "url(#paint0_linear_2666_4202)"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    begin: "0s",
    dur: "2s",
    repeatCount: "indefinite"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2666_4202",
    x1: 2.79397e-7,
    y1: 75,
    x2: 150,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6F10F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopColor: "#EB3776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6436"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocaliqLoading);
export default __webpack_public_path__ + "static/media/localiq-loading.26e661d3222b9a5b1bbf74f7ecf805ea.svg";
export { ForwardRef as ReactComponent };